module.exports = __webpack_public_path__ + "static/img/logo-ba.7a8e566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ba.png
// module id = AyDm
// module chunks = 12